import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

// directives
import {
  AutofocusDirective,
  DelaySkeletonDirective,
  DragAndDropDirective,
  PasswordValidatorDirective,
  TextareaAutosizeDirective,
} from './directive';

// services
import { SeoService } from './global-store';

// guards
import { AuthInterceptor } from './interceptor/auth.interceptor';

// pipes
import { EnumConvertedToArrayPipe, EnumToArrayPipe, GroupByPipe } from './pipe';
import { authServiceProvider } from './service';

@NgModule({
  declarations: [
    PasswordValidatorDirective,
    TextareaAutosizeDirective,
    AutofocusDirective,
    DragAndDropDirective,
    // SafePipe,
    EnumToArrayPipe,
    EnumConvertedToArrayPipe,
    // EnumArrayConvertedToStringPipe,
    GroupByPipe,
    // SafeSrcPipe,
    // LastEightPipe,
    DelaySkeletonDirective,
  ],
  imports: [],
  exports: [
    PasswordValidatorDirective,
    TextareaAutosizeDirective,
    AutofocusDirective,
    DragAndDropDirective,
    // SafePipe,
    EnumToArrayPipe,
    EnumConvertedToArrayPipe,
    // EnumArrayConvertedToStringPipe,
    // LastEightPipe,
    GroupByPipe,
    // SafeSrcPipe,
    DelaySkeletonDirective,
  ],
})
export class SharedModule {
  public static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        SeoService,
        authServiceProvider,
        {
          provide: HTTP_INTERCEPTORS,
          multi: true,
          useClass: AuthInterceptor,
        },
      ],
    };
  }
}
